const sizeMap = {
  lw_size_shoes_adult: 'size_adult',
  lw_size_shoes_kids: 'size_kids',
  lw_size_apparel_kids: 'size_apparel_kids',
  lw_size_apparel_alpha: 'size_alpha',
  lw_size_wader: 'size_wader',
  lw_size_waist: 'waist',
  lw_size_inseam: 'inseam',
};

const getKeyByValue = (value: string) => {
  const entry = Object.entries(sizeMap).find(([_, val]) => val === value);

  return entry ? entry[0] : '';
};

/**
 * 匹配路径和筛选项
 */
export function findMatchingRewrite(aggregations, path) {
  const matchingRewrites = [];
  let temp = path;

  const findIndex = aggregations.findIndex(agg => agg.rewrite === temp);

  if (findIndex > -1) {
    return {
      matchingRewrites: [aggregations[findIndex]['rewrite']],
      remain: '',
    };
  }

  aggregations.forEach(agg => {
    if (temp === '') {
      return;
    }

    const tempSet = new Set(temp.split('-'));
    const rewriteArr = agg.rewrite.split('-');

    // 防止部分匹配

    let flag = true;

    for (let i = 0; i < rewriteArr.length; i++) {
      if (!tempSet.has(rewriteArr[i])) {
        flag = false;
      }
    }

    if (flag && (temp.indexOf(agg.rewrite + '-') > -1 || temp.indexOf('-' + agg.rewrite) > -1)) {
      matchingRewrites.push(agg.rewrite);
      temp = temp.replace(agg.rewrite, '');
    }
  });

  return {
    matchingRewrites,
    remain: temp.replace('-', ''),
  };
}

/**
 * 根据筛选状态生成路径
 * @param {*} aggregations
 * @param {*} initialPath
 * @param {*} filterKeys
 * @param {*} filterState
 * @param {*} filters
 * @returns
 */

type FilterState = Map<string, Set<{ title: string; value: string } | string[]>>;

export const getPathFromState = ({
  aggregations,
  initialPath,
  filterState,
}: {
  aggregations: {
    code: string;
    option_id: string;
    rewrite: string;
    label?: string;
    swatch_data: {
      value?: string;
      thumbnail?: string;
    };
  }[];
  initialPath: string;
  filterState: FilterState;
  categoryUrlKey: string;
}) => {
  const initialPathArr: string[] = initialPath.split('/');

  const findDe = initialPathArr.findIndex(item => item === 'de');

  const isDE = process.env.NEXT_PUBLIC_STORE_VIEW_CODE === 'hisea_de';

  const categoryUrlKeyUS = initialPath?.split('/')?.[0] || initialPath?.split('/')?.[1];

  const categoryUrlKeyDE = isDE ? initialPathArr[findDe + 1] : categoryUrlKeyUS;

  const categoryUrlKey = isDE ? categoryUrlKeyDE : categoryUrlKeyUS;

  const categoryArray: string[] = [isDE ? 'de' : '', categoryUrlKey]; // 分类路径
  const filterValueArr: string[] = [];
  const pageArray: string[] = []; // 分页路径

  // 添加 rewrite 作为路径
  const processValueRewrite = (value: { title: string; value: string }) => {
    const findAggregation = aggregations.find(temp => temp.option_id === value.value);

    if (findAggregation?.rewrite) {
      filterValueArr.push(findAggregation.rewrite);
    }
  };

  const handleFilter = ({
    filterName,
    pathName,
    processValue,
  }: {
    filterName: string;
    pathName: string;
    // eslint-disable-next-line no-unused-vars
    processValue: (value: any) => void;
  }) => {
    if (filterState.has(filterName)) {
      const values = filterState.get(filterName) as Set<{
        title: string;
        value: string;
      }>;

      if (pathName) {
        filterValueArr.push(pathName);
      }

      for (const value of Array.from(values)) {
        if (typeof processValue === 'function') {
          processValue(value);
        }
      }
    }
  };

  // 添加 title 作为路径
  // const processValueWithTitle = (value: any) => {
  //   if (value?.title) {

  //     console.log("使用 title 作为路径 ===>", value?.title);

  //     const transformedTitle = value.title.toLowerCase().replace(/ /g, "-");

  //     filterValueArr.push(transformedTitle);
  //   }
  // }

  // Array.from(filterState.entries()).forEach(([filterName, values]) => {
  //   if ([
  //     "lw_product_usage",
  //     "lw_color",
  //     "lw_material",
  //     "lw_material_clothing",
  //     "price",
  //     ...Object.values(sizeMap)
  //   ].includes(filterName)) {
  //     return;
  //   }

  //   handleFilter({
  //     filterName: filterName,
  //     pathName: filterName.replace("lw_size_", ""),
  //     processValue: processValueRewrite
  //   });
  // })

  // size
  Object.entries(sizeMap).forEach(([filterName, pathName]) => {
    handleFilter({
      filterName,
      pathName,
      processValue: processValueRewrite,
    });
  });

  handleFilter({
    filterName: 'lw_product_usage',
    pathName: '',
    processValue: processValueRewrite,
  });
  handleFilter({
    filterName: 'lw_color',
    pathName: 'color',
    processValue: processValueRewrite,
  });
  handleFilter({
    filterName: 'lw_material',
    pathName: '',
    processValue: processValueRewrite,
  });
  handleFilter({
    filterName: 'lw_material_clothing',
    pathName: 'material_clothing',
    processValue: processValueRewrite,
  });

  // 处理其他未明确列出的筛选项（如 lw_boot_height 等）
  Array.from(filterState.keys()).forEach(filterName => {
    const alreadyHandled = [
      ...Object.keys(sizeMap),
      'lw_product_usage',
      'lw_color',
      'lw_material',
      'lw_material_clothing',
      'price',
    ];
    if (alreadyHandled.includes(filterName)) return;

    handleFilter({
      filterName,
      pathName: '',
      processValue: processValueRewrite,
    });
  });

  handleFilter({
    filterName: 'price',
    pathName: 'price',
    processValue: (value: string[]) => {
      const priceArray = value.join('-');

      filterValueArr.push(priceArray);
    },
  });

  const nextPath = `/${categoryArray.join('/')}/${filterValueArr.join('/')}/${pageArray.join('/')}`.replace(
    /\/+/g,
    '/',
  );

  return nextPath;
};

export const getStateFromPath = ({
  categoryUrlKey,
  aggregations = [],
  sortFields,
  pathname,
  filters,
}: {
  categoryUrlKey: string;
  aggregations: any[];
  sortFields: any[];
  pathname: string;
  filters: any[];
}) => {
  const nextState = new Map();

  const pathArr = pathname.split('/');

  // 过滤掉分页的和二级目录页
  const filteredPathArr = pathArr.filter((subPath, index) => {
    if (index > 0 && pathArr[index - 1] === 'p' && /\d+/.test(subPath)) {
      return false;
    }

    if (subPath === 'p') {
      return false;
    }

    if (subPath === categoryUrlKey) {
      return false;
    }

    return subPath !== '' && sortFields.findIndex(item => item.value === subPath) === -1;
  });

  function getCurrentFilterId({ filterCode, rewrite }: { filterCode: string; rewrite: string }) {
    const findFilter = aggregations.filter(item => item.code === filterCode);

    const findFilterItem = findFilter?.find(item => item.rewrite === rewrite);

    return findFilterItem;
  }

  function findFilterOptions({ attributeCode, filterId }: { attributeCode: string; filterId: string }) {
    const findFilters = filters.find(item => item.attribute_code === attributeCode);

    const options = findFilters?.options;

    const findOption = options?.find((temp: any) => temp.value === filterId);

    return findOption;
  }

  // color
  function handleAttributeCode(attributeCode: string, subPath: string) {
    const currentFilter = getCurrentFilterId({
      filterCode: attributeCode,
      rewrite: subPath,
    });

    const currentFilterOption = findFilterOptions({
      attributeCode: attributeCode,
      filterId: currentFilter?.option_id,
    });

    if (currentFilterOption) {
      handleSetNextState(attributeCode, currentFilterOption);
    }
  }

  function handleRewite(subPath: string) {
    const findAggregation = aggregations.find(temp => temp.rewrite === subPath);

    if (!findAggregation) {
      return;
    }

    const attributeCode = findAggregation.code;
    const matchFilter = filters.find(temp => temp.attribute_code === attributeCode);

    if (!matchFilter) {
      return;
    }

    const options = matchFilter.options;
    const findOption = options.find((temp: any) => temp.value.toString() === findAggregation.option_id.toString());

    if (findOption) {
      handleSetNextState(attributeCode, findOption);
    }
  }

  // set 到 nextState
  function handleSetNextState(attributeKey: string, option: any) {
    if (nextState.has(attributeKey)) {
      const preItems = nextState.get(attributeKey);

      preItems.add({
        title: option.label,
        value: option.value,
      });
    } else {
      const items = new Set();

      items.add({
        title: option.label,
        value: option.value,
      });
      nextState.set(attributeKey, items);
    }
  }

  // 前面的是 url 路径，后面的是 nextState 的 key, 通过 title 匹配
  const attributeMapping: Record<string, string> = {
    color: 'lw_color',
    material_clothing: 'lw_material_clothing',
  };

  const sizeMapping = Object.values(sizeMap);

  filteredPathArr.forEach((subPath, index) => {
    const key = filteredPathArr[index - 1];
    const keyIsColor = attributeMapping.hasOwnProperty(key);
    const keyIsSize = sizeMapping.includes(key);
    const keyIsPrice = key === 'price';

    // 当前的 subpath
    const subPathIsColor = subPath === 'color';
    const subPathIsSize = sizeMapping.includes(key);
    const subPathIsPrice = subPath === 'price';

    // 通过 label 匹配 color
    if (keyIsColor) {
      handleAttributeCode(attributeMapping[key], subPath);
    }

    if (keyIsSize) {
      handleAttributeCode(getKeyByValue(key), subPath);
    }

    if (keyIsPrice) {
      const priceArray = subPath.split('-');

      if (nextState.has('price')) {
        const preItems = nextState.get('price');

        preItems.add(priceArray);
      } else {
        const items = new Set();

        items.add(priceArray);
        nextState.set('price', items);
      }
    }

    // 前面既不是 color ,也不包含 size, 也不是 price,
    // 当前的 subPath 不是 color, 不是 size, 不是 price
    if (!keyIsColor && !keyIsSize && !keyIsPrice && !subPathIsColor && !subPathIsSize && !subPathIsPrice) {
      handleRewite(subPath);
    }
  });

  return nextState;
};

// 找出分类页路径里无法识别的段。
//
// getStateFromPath 对匹配不上的段是静默忽略的，于是 /{分类}/{任意字符串} 会渲染出
// 父分类的完整内容（商品数与父分类一致），canonical 却自指 —— Google 判为重复页，
// 即 GSC「Google另选规范网页」报告里的那批 URL。这类路径可以被无限构造，
// 逐条配 301 治不完，所以在路由层直接判掉。
//
// 判定保持宽松：只要能归入「分类名 / 分页 / 排序 / 筛选 key / 紧跟 key 的取值 /
// 分层导航 rewrite」之一就放行，不校验取值内容，避免误杀正常筛选页。
export const findUnknownPathSegments = ({
  categoryUrlKey,
  aggregations = [],
  sortFields = [],
  pathname,
}: {
  categoryUrlKey: string;
  aggregations: any[];
  sortFields: any[];
  pathname: string;
}) => {
  const pathArr = pathname.split('/').filter(Boolean);
  const filterKeys = ['color', 'material_clothing', 'price', ...Object.values(sizeMap)];

  return pathArr.filter((subPath, index) => {
    const prev = index > 0 ? pathArr[index - 1] : '';

    // 分类自身
    if (subPath === categoryUrlKey) return false;
    // 旧 Magento 分页地址 /p/2
    if (subPath === 'p') return false;
    if (prev === 'p' && /^\d+$/.test(subPath)) return false;
    // 排序字段
    if (sortFields.some((item: any) => item?.value === subPath)) return false;
    // 筛选的 key 段（color / size_adult / price …）
    if (filterKeys.includes(subPath)) return false;
    // 紧跟在 key 段之后的取值段
    if (filterKeys.includes(prev)) return false;
    // 分层导航的单段 rewrite（ankle / midcalf / pvc …）
    if (aggregations.some((item: any) => item?.rewrite === subPath)) return false;

    return true;
  });
};

export const DELIMITER = ',';

export const getSearchFromState = (initialPath, filterKeys, filterState) => {
  // preserve all existing params
  const nextParams = new URLSearchParams(initialPath);

  // iterate over available filters
  for (const key of filterKeys.keys()) {
    // remove any existing filter values
    nextParams.delete(`${key}_filter`);
  }

  // iterate over the latest filter values
  for (const [group, items] of filterState) {
    if (group === 'price') {
      for (const item of items) {
        nextParams.append(`${group}_filter`, `${item[0]}-${item[1]}`);
      }
    } else {
      for (const item of items) {
        const { value } = item || {};

        // append the new values
        nextParams.append(`${group}_filter`, `${value}`);
      }
    }
  }

  return `?${nextParams.toString()}`;
};

export const getStateFromSearch = (initialPath, filterKeys, filterItems) => {
  // preserve all existing params
  const params = new URLSearchParams(initialPath);
  const uniqueKeys = new Set(params.keys());
  const nextState = new Map();

  // iterate over existing param keys
  for (const key of uniqueKeys) {
    // if a key matches a known filter, add its items to the next state
    if (filterKeys.has(key.replace('_filter', '')) && key.endsWith('_filter')) {
      // derive the group by slicing off `_filter`
      const group = key.slice(0, -7);
      const items = new Set();
      const groupItemsByValue = new Map();

      if (group === 'price') {
        for (const value of params.getAll(key)) {
          items.add(value.split('-'));
        }
      } else {
        // cache items by value to avoid inefficient lookups
        for (const item of filterItems.get(group)) {
          groupItemsByValue.set(item.value, item);
        }

        // map item values to items
        for (const value of params.getAll(key)) {
          const existingFilter = groupItemsByValue.get(getValueFromFilterString(value));

          if (existingFilter) {
            items.add(existingFilter);
          } else {
            // console.warn(
            //     `Existing filter ${value} not found in possible filters`
            // )
          }
        }
      }

      // add items to the next state, keyed by group
      nextState.set(group, items);
    }
  }

  return nextState;
};

export const getFiltersFromSearch = searchParams => {
  // preserve all existing params
  const uniqueKeys = new Set(searchParams.keys());
  const filters = new Map();

  // iterate over existing param keys
  for (const key of uniqueKeys) {
    // if a key matches a known filter, add its items to the next state
    if (key.endsWith('_filter')) {
      // derive the group by slicing off `_filter`
      const group = key.slice(0, -7);
      const items = new Set();

      // map item values to items
      for (const value of searchParams.getAll(key)) {
        items.add(value);
      }

      // add items to the next state, keyed by group
      filters.set(group, items);
    }
  }

  return filters;
};

/**
 * Sort filters array
 * @param {Array} initialArray an array containing filters data
 */
export const sortFiltersArray = initialArray => {
  return initialArray.sort((a, b) => {
    // Place Category filter first
    if (a['attribute_code'] === 'category_id' || a['attribute_code'] === 'category_uid') {
      return -1;
    }

    if (b['attribute_code'] === 'category_id' || b['attribute_code'] === 'category_uid') {
      return 1;
    }

    // Sort alphabetically if same position
    if (a['position'] === b['position']) {
      if (a['label'] < b['label']) {
        return -1;
      }

      if (a['label'] > b['label']) {
        return 1;
      }
    }

    // Sort by position
    return a['position'] - b['position'];
  });
};

export const stripHtml = html => html.replace(/(<([^>]+)>)/gi, '');

const getValueFromFilterString = value => value;

/**
 * Converts a set of values to a range filter
 * @param {Set} values
 */
const toRangeFilter = values => {
  const rangeString = Array.from(values)[0];

  const [from, to] = rangeString.split('_');
  const rangeFilter = {
    from,
    to,
  };

  if (rangeFilter.from === '*') {
    delete rangeFilter.from;
  }

  if (rangeFilter.to === '*') {
    delete rangeFilter.to;
  }

  return rangeFilter;
};

/**
 * Converts a set of values into an equals filter
 * @param {Set} values
 */
const toEqualFilter = values => {
  if (values.size > 1) {
    return {
      in: Array.from(values).map(getValueFromFilterString),
    };
  }

  return {
    eq: getValueFromFilterString(Array.from(values)[0]),
  };
};

/**
 * Converts a set of values into a match filter
 * @param {Set} values
 */
const toMatchFilter = values => {
  return {
    match: getValueFromFilterString(Array.from(values)[0]),
  };
};

const CONVERSION_FUNCTIONS = {
  FilterEqualTypeInput: toEqualFilter,
  FilterMatchTypeInput: toMatchFilter,
  FilterRangeTypeInput: toRangeFilter,
};

export const getFilterInput = (values, type) => {
  const conversionFunction = CONVERSION_FUNCTIONS[type];

  if (!conversionFunction) {
    throw TypeError(`Unknown type ${type}`);
  }

  return conversionFunction(values);
};
